import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=54039acd&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=54039acd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54039acd",
  null
  
)

export default component.exports